<template>
    <nav class="navbar navbar-expand">
        <div class="container">
            <div class="return">
                <!--<i class="fa-solid fa-rotate-left"></i>-->
            </div>
            <a class="navbar-brand d-block" href="#">D`Match</a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTop"
                aria-controls="navbarTop" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarTop">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">

                </ul>
                <div class="flex-shrink-0 dropdown">
                    <a href="#" class="d-block link-body-emphasis text-decoration-none dropdown-toggle"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <img src="https://github.com/mdo.png" alt="mdo" width="32" height="32"
                            class="rounded-circle me-1">
                        <span class="d-none d-sm-inline">Luan Nascimento</span>
                    </a>
                    <ul class="dropdown-menu text-small shadow">
                        <li><a class="dropdown-item" href="#">Profile</a></li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li><a class="dropdown-item" href="#">Sign out</a></li>
                        <button id="theme-toggle" class="btn btn-sm btn-outline-secondary text-end"><i class="fa-solid fa-moon"></i></button>
                    </ul>
                </div>                
            </div>
        </div>
    </nav>
</template>

<script setup></script>

<style scoped>
.navbar {
    background-color: #7e52d9;
}
.return {
    width: 34px;
}

@media (max-width: 767.98px) {
    .navbar-brand {
        text-align: center;
        width: 100%;
    }
}
</style>